






























































import { Vue, Component } from 'vue-property-decorator';
import PickerInput from '../components/PickerInputold.vue';
import { Popup, Picker, Toast } from 'vant';
import { isWeiXin } from '@/common/ts/common';
import { saveuser, checkUser } from '../api';
import clounbtn from '../components/CloundbtnInfo.vue';
import qs from 'qs';

@Component({
  components: {
    PickerInput,
    clounbtn,
  },
})
export default class Rule extends Vue {
  isInto: boolean = true;
  subbtn: any = require('../assets/info/infobtn.png');
  rulecontent: any = '';
  name: string = '';
  unionid: string | null = '';
  options: any = ['抖音', '微博', '小红书', 'b站'];
  platform: string = '';
  platformId: string = '';
  schname: string = '';
  phone: string = '';
  isclick: boolean = false;

  mounted() {
    this.unionid = window.localStorage.getItem('unionid');
    if (!isWeiXin()) {
      Toast('请在微信中打开，参与活动');
      return false;
    } else if (
      (this.unionid === null || this.unionid === 'null') &&
      isWeiXin()
    ) {
      this.WechatLogin();
      return false;
    }
    checkUser(this.unionid + '').then((res: any) => {
      if (res.code === 200) {
        this.$router.push('succesinfo');
      } else {
        if (res.code !== 400) {
          Toast(res.msg);
        }
      }
    });
    this.isInto = true;
    setTimeout(() => {
      this.isInto = false;
    }, 200);
  }
  goback() {
    this.$router.push('index');
  }
  selectData1(e: any) {
    this.platform = e + '';
  }
  submitInfo() {
    if (this.isclick) {
      return false;
    }
    this.isclick = true;
    if (!this.name) {
      this.isclick = false;
      Toast('请填写姓名！');
      return false;
    } else if (!/^1[345789][0-9]{9}$/.test(this.phone)) {
      this.isclick = false;
      Toast('电话号码格式错误！');
      return false;
    } else if (!this.schname) {
      this.isclick = false;
      Toast('请输入学校名称！');
      return false;
    } else if (!this.platform) {
      this.isclick = false;
      Toast('请选择平台！');
      return false;
    } else if (!this.platformId) {
      this.isclick = false;
      Toast('请输入平台ID！');
      return false;
    } else {
      this.isclick = false;
      this.submitPerson();
    }
  }
  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx536e2bb3e4f6664f';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
  async submitPerson() {
    this.unionid = window.localStorage.getItem('unionid');
    if (!isWeiXin()) {
      Toast('请在微信中打开，参与活动');
      return false;
    } else if (!this.unionid && isWeiXin()) {
      this.WechatLogin();
      return false;
    }
    const data = {
      unionid: this.unionid,
      name: this.name,
      phone: this.phone,
      platform: this.platform,
      platformId: this.platformId,
      schname: this.schname,
      wxheadimg: window.localStorage.getItem('headimgurl'),
    };
    saveuser(data).then((res: any) => {
      if (res.code === 200) {
        this.$router.push('succesinfo?canmodify=' + 1);
      } else {
        Toast(res.msg);
      }
    });
  }
}
